import fetchJsonp from 'fetch-jsonp';
import { TwitterPublicSuggestionResponse } from './types';

export enum TwitterSuggestionResultType {
  Mentions = 'mentions',
  Hashtags = 'hashtags',
}

export function getTwitterPublicSuggestions(
  search: string,
  resultType = TwitterSuggestionResultType.Mentions
): Promise<TwitterPublicSuggestionResponse> {
  return fetchJsonp(
    `https://twitter.com/i/search/typeahead.json?count=10&filters=true&result_type=${resultType}&src=COMPOSE&q=${search}`
  )
    .then((response) => response.json())
    .catch((error) => {
      if (
        error.message.startsWith('JSONP request to') &&
        error.message.endsWith('timed out')
      ) {
        throw new Error(
          `Whoops, Twitter's servers couldn't be reached for the tagging 
          of Twitter usernames to work, sorry about that. 
          Would you be up for trying again? If this error continues 
          to show up, please feel free to reach out to us!`
        );
      } else {
        throw new Error(
          `Whoops, suggestions don't seem to be working right now, 
          sorry about that. Would you be up for trying again? 
          If this error continues to show up, please feel 
          free to reach out to us with the following error 
          message: <pre>${error.message}</pre>`
        );
      }
    });
}
